import React from 'react';
import { useTranslation } from 'react-i18next';

import { reloadPage } from '../../../../utils/platform/reload-page';
import AppButton from '../../../designe/buttons/app-button/AppButton';
import CommonErrorPage from '../CommonErrorPage/CommonErrorPage';

const SomethingWentWrongPage = () => {
  const { t } = useTranslation();

  const refresh = () => {
    reloadPage();
  };

  return (
    <CommonErrorPage
      errorImage={null}
      title={t('errorPages.somethingWentWrong.title')}
      description={t('errorPages.somethingWentWrong.description')}
      buttonText={t('errorPages.somethingWentWrong.goHome')}>
      <AppButton
        sx={(theme) => ({
          fontSize: 14,
          fontWeight: 700,
          color: theme.palette.common.white,
          backgroundColor: theme.palette.primary.main,
          marginBottom: theme.spacing(2),
        })}
        variant="contained"
        onClick={refresh}>
        {t('errorPages.somethingWentWrong.refreshButton')}
      </AppButton>
    </CommonErrorPage>
  );
};

export default SomethingWentWrongPage;
